function ValidateApiKey(apiKey) {
	var validationErrors = [];                
	if (!apiKey.name || apiKey.name === '') {                    
		addErrorMessage(validationErrors, 'name', 'ApiKey name is empty');
	}
	
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateApiKey;